import { LOCALES } from '../constants';

const ru = {
	[LOCALES.ru]: {
		Russian: 'Русский',
		English: 'English',
		Ukrainian: 'Українська',
		Authorization: 'Авторизация',
		Registration: 'Регистрация',
		'Your account has been blocked': 'Ваш аккаунт заблокирован',
		'Please contact support for assistance': 'Пожалуйста, свяжитесь со службой поддержки',
		'Contact support': 'Связаться с поддержкой',
		'Yes, change': 'Да',
		No: 'Нет',
		'Re-enter hash': 'Повторно ввести хэш',
		'Are you sure you have to re-enter the hash?': 'Вы уверены, что вам нужно повторно ввести хэш?',
		'Your request is being processed': 'Ваш запрос обрабатывается',
		'Your unblock request has been sent to support': 'Ваш запрос на разблокировку отправлен в службу поддержки',
		Back: 'Назад',
		'First login attempt is failed': 'Первая попытка входа не удалась',
		'Oops! Something went wrong. Please try again.': 'Упс! Что-то пошло не так. Пожалуйста, попробуйте снова.',
		'An error occurred': 'Произошла ошибка',
		Refresh: 'Обновить',
		'QR code reading error': 'Ошибка чтения QR-кода',
		'Try again': 'Повторить',
		'Authorization failed': 'Авторизация не удалась',
		'First login': 'Первый вход',
		'Enter your login': 'Введите логин',
		'I agree to the': 'Я согласен с',
		'Terms of Use and the Public Offer Agreement': 'Условиями использования и Договором публичной оферты',
		Continue: 'Продолжить',
		'Create new password': 'Создайте новый пароль',
		'Enter your password': 'Введите пароль',
		'Repeat your password': 'Повторите пароль',
		'The password must contain 6 - 64 characters, including lowercase and uppercase Latin letters and at least one number.':
			'Пароль должен содержать от 6 до 64 символов, включая строчные и заглавные латинские буквы, и хотя бы одну цифру.',
		'Hash or QR is invalid': 'Хэш или QR-код недействителен',
		'I Agree': 'Соглашаюсь',
		'Incorrect login': 'Неверный логин',
		'Exceeded the number of registration attempts! Login blocked for {min} min {sec} sec':
			'Превышено количество попыток регистрации.\nВход заблокирован на {min} мин {sec} сек.',
		'Passwords are different': 'Пароли не совпадают',
		'Enter hash or scan QR code': 'Введите хеш или отсканируйте QR-код',
		Paste: 'Вставить',
		"Password doesn't match": 'Пароль не совпадает',
		Login: 'Логин',
		'Enter your login and password': 'Введите свой логин и пароль',
		'Login or password is incorrect': 'Неправильный логин или пароль',
		'Exceeded the number of authorization attempts! Login blocked fo {m} min {s} sec':
			'Превышено количество попыток авторизации!\nЛогин заблокирован на {m} мин {s} сек',

		'Welcome to {br} {billingName} Wallet': 'Добро пожаловать {br} в {billingName} кошелек',
		'Your personal crypto wallet for everyday payments and work with cryptocurrency.':
			'Ваш персональный криптокошелек для повседневных платежей и работы с криптовалютой.',
		'Sign up': 'Регистрация',
		'Sign in': 'Вход',

		'Crypto portfolio': 'Портфолио',
		Send: 'Отправить',
		Receive: 'Получить',
		Sent: 'Отправлено',
		Received: 'Получено',
		Assets: 'Активы',
		History: 'История',
		Address: 'Адрес',
		Addresses: 'Адреса',
		'All addresses': 'Все адреса',
		Account: 'Аккаунт',
		Hash: 'Хэш',
		Password: 'Пароль',
		Success: 'Успех',
		Cancel: 'Отмена',

		'Select network': 'Выбор сети',

		'Your password': 'Ваш пароль',
		'Scan the QR code': 'Отсканируйте QR-кода',
		'Point your camera at the QR code with the address.': 'Наведите камеру на QR-код с адресом.',
		'Upload QR code': 'Загрузить QR-код',
		'Select asset': 'Выберите актив',
		'Select address': 'Выберите адрес',
		'Enter payment details': 'Введите платежные данные',
		'Confirm payment': 'Подтвердите платеж',
		'This address does not belong to the blockchain {currency}': 'Данный адрес не принадлежит блокчейну {currency}',
		'The minimum withdrawal amount is {amount} {currency}': 'Минимальная сумма перевода составляет {amount} {currency}',
		'The amount exceeds the balance on the address': 'Сумма перевода превышает остаток на адресе',
		Send_v2: 'Перевод',
		Send_v3: 'Перевести',
		Step: 'Шаг {number}',
		'Use {currency} and save money': 'Используйте {currency} и экономьте',
		'Learn more': 'Узнать больше',
		'Select an asset for payment': 'Выберите актив для оплаты',
		'Enter payment information': 'Введите платежную информацию',
		'Recipient address': 'Адрес получателя',
		'Type recipient address': 'Введите адрес получателя',
		'Transaction fee': 'Комиссия за транзакцию',
		'Learn about transaction fees': 'Узнайте о комиссии за транзакцию',
		'This is the fee paid to the blockchain to process your transaction. Transaction speed depends on the fee amount: higher fees are usually confirmed faster':
			'Это сумма, выплачиваемая блокчейну за обработку вашей транзакции. Скорость подтверждения зависит от размера комиссии: обычно более высокая комиссия обеспечивает более быструю обработку.',
		'Use a single transaction for inputs': 'Использовать одну транзакцию для входов',
		'All inputs will be combined into one transaction. This can lower the total fee but increases the chance that those addresses will be linked on the blockchain.':
			'Все входы будут собраны в одну транзакцию. Это может снизить общую сумму комиссии, но увеличивает вероятность связывания этих адресов в блокчейне.',
		'Note: combining inputs within a single transaction may result in visible linkage between addresses at the blockchain level. Consider this when choosing how inputs are processed.':
			'Примечание: объединение входов в рамках одной транзакции может привести к видимой связи между адресами на уровне блокчейна. Учитывайте это при выборе способа обработки входов.',
		'Got it': 'Понятно',
		'A minimum of 35 TRX is required for guaranteed withdrawal. The real cost depends on the payment and takes a smaller amount':
			'Для гарантированной отправки транзакции требуется не менее 35 TRX. Фактический расход зависит от платежа и составит меньшую сумму',
		Amount: 'Сумма перевода',
		Available: 'Баланс',
		'Send max': 'Вставить все',
		'Fee amount': 'Комиссия',
		Fee: 'Комиссия',
		Comment: 'Комментарий',
		Success_v2: 'Успешно',
		Comments: 'Комментарий',
		'Transaction details': 'Детали транзакции',
		'View on block explorer': 'Открыть в блокчейн-эксплорере',
		'only you can see': 'виден только вам',
		Optional: 'Опционально',
		Amount_v2: 'Сумма',
		'To be withdraw': 'Сумма вывода',
		'To be receive by recipient': 'Сумма, которую получит пользователь',
		'Sender address': 'Адрес отправителя',
		'Fee details': 'Комиссия',
		'Fee from': 'Комиссия с',
		'Fee amount_v2': 'Сумма комиссии',
		Confirm: 'Подтвердить',
		Details: 'Детали',
		None: 'Отсутствует',
		Queued: 'В очереди',
		Completed: 'Завершено',
		Failed: 'Неуспешно',
		Processing: 'В обработке',
		'Waiting confirmation': 'Ожидание подтверждения',
		Cancelled: 'Отменено',
		'To be withdraw_v2': 'Сумма вывода',
		'To be receive by recipient_v2': 'Сумма, которую получил пользователь',
		Date: 'Дата',
		Status: 'Статус',
		Copy: 'Скопировать',
		Share: 'Поделиться',
		Information: 'Информация',
		'View on Tronscan': 'Просмотреть на Tronscan',
		'View on Etherscan': 'Просмотреть на Etherscan',
		'Send only {currency} to this address on the {network} network, otherwise you may lose your funds.':
			'Отправляйте только {currency} на этот адрес в сети {network}, иначе вы можете потерять свои средства.',
		'Share your QR code': 'Поделитесь QR-кодом',
		'Risk level': 'Уровни риска',
		'AML check': 'AML-проверка',
		'Address for AML check': 'Адрес для AML-проверки',
		'Auto-detected. Select manually if needed.': 'Определяется автоматически. При необходимости можно выбрать вручную.',
		'The network could not be detected automatically.\nPlease select the network manually.':
			'Сеть не удалось определить автоматически.\nПожалуйста, выберите сеть вручную.',
		Reset: 'Сбросить',
		'Insufficient balance for this payment methods.': 'Недостаточно средств для этого способа оплаты.',
		'Price per check': 'Стоимость проверки',
		'AML check V2': 'Запустить AML-проверку',
		'Scan address': 'Сканировать адрес',
		'Low risk': 'Низкий риск',
		'Medium risk': 'Средний риск',
		'High risk': 'Высокий риск',
		'Outdated risk': 'Устаревший риск',
		'Unchecked risk': 'Непроверенный риск',
		'Check AML risk': 'Проверить AML-риск',
		'In progress V2': 'В процессе',
		'AML Details': 'Детали AML',
		'Source of funds': 'Источник средств',
		'Use of funds': 'Использование средств',
		Category: 'Категория',
		'Share V2': 'Доля',
		'Recheck address': 'Повторно проверить адрес',
		Counterparties: 'Контрагенты',
		Transactions: 'Транзакции',
		'All balance': 'Весь баланс',
		'Last check': 'Проверено',
		'Part of the funds associated with high-risk sources.': 'Часть средств, связанная с источниками высокого риска.',
		'All connections': 'Все подключения',
		'Source of funds Avg. risk (%)': 'Источник средств\nСред. риск (%)',
		'Use of funds Avg. risk (%)': 'Использование средств\nСред. риск (%)',
		'How funds are categorized by risk level based on their origin and the destinations they were sent to.':
			'Как средства распределены по уровням риска в зависимости от того, откуда они поступили и куда были отправлены.',
		Low: 'Низкий',
		Medium: 'Средний',
		High: 'Высокий',
		Settled: 'Settled',
		Uncategorized: 'Без категории',

		'High-risk % shows the portion of funds associated with high-risk sources.':
			'% Высокого риска показывает часть средств, связанных с источниками повышенного риска.',
		'This percentage reflects the combined contribution of funds linked to sources classified as high risk, such as sanctions, scams, stolen funds, terrorism financing, and other suspicious activities.\nA higher value does not represent the overall AML risk level of the address. It indicates that part of the funds originates from high-risk sources and may require additional attention during compliance checks.':
			'Этот процент отражает совокупную долю средств, связанных с источниками, классифицированными как высокорисковые — такими как санкции, мошенничество, украденные средства, финансирование терроризма и другая подозрительная активность.\nБолее высокое значение не означает общий уровень AML-риска адреса. Оно указывает на то, что часть средств поступает из источников повышенного риска и может требовать дополнительного внимания при проверке.',
		'Review the AML details to understand the source and use of funds.\nUse this information to make an informed decision before interacting with these assets.':
			'Ознакомьтесь с детальными AML-данными, чтобы понять источник и использование средств.\nИспользуйте эту информацию для принятия взвешенного решения перед взаимодействием с этими активами.',

		'This AML result may no longer reflect the current state of the address.\nWe recommend running a new AML check to get up-to-date information.':
			'Результат AML-проверки может больше не отражать текущее состояние адреса.\nРекомендуем запустить новую AML-проверку, чтобы получить актуальную информацию.',

		'Why this address has no AML result yet': 'Почему для адреса нет результата AML',
		'This address has not been checked for AML risks yet.': 'Этот адрес ещё не проходил проверку на AML-риски.',
		'There is not enough data to assess the risk level of this address at the moment.\nAn unchecked status does not indicate low or high risk — it means the risk has not been evaluated.':
			'В данный момент недостаточно данных для оценки уровня риска этого адреса.\nСтатус «не проверен» не означает низкий или высокий риск — это означает, что риск ещё не оценивался.',
		'Run an AML check to check the address, calculate its risk score, and view detailed information about the source and use of funds.':
			'Запустите AML-проверку, чтобы проверить адрес, рассчитать его уровень риска и получить подробную информацию об источнике и использовании средств.',

		'AML Risk': 'AML-риск',
		'How AML risk is calculated': 'Как рассчитывается AML-риск',

		'AML check is in progress.': 'AML-проверка выполняется.',
		'This may take some time. You can continue using the wallet as usual.\nYou will be notified once the check is complete.':
			'Это может занять некоторое время. Вы можете продолжать пользоваться кошельком как обычно.\nВы получите уведомление после завершения проверки.',

		'This address has not been AML-checked yet.\nPlease run an AML check before sending funds.':
			'Этот адрес ещё не проходил AML-проверку.\nПожалуйста, выполните AML-проверку перед отправкой средств.',
		'Check address now': 'Проверить адрес',
		'Estimated time': 'Примерное время',

		Asset: 'Актив',
		Network: 'Сеть',
		Error: 'Ошибка',
		'Address copied': 'Адрес скопирован',
		'Hash copied': 'Хэш скопирован',
		'There are no transactions yet': 'Транзакций пока еще нет',
		'Transaction fee will be calculated automatically': 'Комиссия транзакции будет рассчитана автоматически',
		'In progress': 'В обработке',
		'You cannot send funds to the same address': 'Нельзя переводить средства на тот же адрес',
		'Error in calculating withdrawal fees': 'Ошибка рассчета комиссии вывода',
		'Error in preparing withdrawal data': 'Ошибка при подготовке данных вывода',
		'Withdrawal transaction successfully created': 'Транзакция вывод средств успешно создана',
		'Error confirmating the withdrawal': 'Ошибка при подтверждении вывода',
		'Salary wallet': 'Зарплатный кошелек',
		'Not enough TRX to create transaction': 'Недостаточно TRX для выполнения транзакции',
		'Enter your Pin-code': 'Введите ваш пин-код',
		'Pin-code is incorrect. Try again': 'Пин-код неверный. Попробуйте еще',
		'Create PIN-code': 'Создать пин-код',
		'Confirm PIN-code': 'Подтвердить пин-код',
		'Pin-code will be used to confirm transactions.': 'Пин-код будет использован для подтверждения транзакций',
		"Pin-code doesn't match. Try again": 'Пин-код не совпадает. Попробуйте еще',
		"Error! You're trying to login to Mobile account from wrong Telegram":
			'Ошибка! Вы пытаетесь зайти в аккаунт Мобайла не с той учетной записи Telegram',
		'The previous transaction is being processed. Please wait for confirmation before creating the next one.':
			'Предыдущая транзакция в обработке. Пожалуйста, подождите подтверждения, прежде чем создавать следующую.',
		'Top up': 'Пополнить',
		'Top up2': 'Пополнение',
		'Fee payment': 'Оплата комиссии',
		'Show more': 'Показать ещё',
		'How to use {currency}': 'Как использовать {currency}',
		'{currency} are internal units for use only within {productName}. They cannot be withdrawn or converted. Value: 1 {currency} = 1 USD.':
			'{currency} — это внутренняя единица, используемая исключительно в системе {productName}. Они не подлежат выводу или конвертации. Стоимость: 1 {currency} = 1 USD.',
		'Pay fees': 'Оплата комиссий',
		'TRON fees can be paid using {currency}, simplifying fee management for outgoing transactions.':
			'Комиссии в сети TRON можно оплачивать с помощью {currency} — это упрощает управление комиссиями при исходящих операциях.',
		'Read more': 'Подробнее',

		'My address': 'Мой адрес',

		'No transactions yet': 'Пока нет транзакций',
		"You don't have any assets available to receive yet.": 'У вас пока нет доступных активов для получения.',

		'Cover fees for outgoing transactions and save up to 50%.':
			'Оплачивайте комиссии за исходящие транзакции и экономьте до 50%.',
		'Cover network fees for outgoing transactions using {currency}.':
			'Оплачивайте сетевые комиссии за исходящие транзакции с использованием {currency}.',
		'Pay for AML checks': 'Оплата AML-проверок',
		'AML checks reveal the origin of funds and protect you from asset blocking or freezing. Run a check now -  peace of mind is priceless!':
			'AML-проверка определяет происхождение средств и помогает избежать блокировок и заморозки активов. Сделайте проверку сейчас - ваше спокойствие того стоит!',
		'Coming soon': 'Скоро будет доступно',
		"Stay tuned for updates and don't miss new features as they roll out":
			'Следите за обновлениями и не пропустите новые возможности.',

		'Add address': 'Добавить адрес',
		'Give a name': 'Укажите название',
		'Enter a title to easily identify this address.': 'Введите название, чтобы проще различать адреса.',

		Expence: 'Расход',
		'{billingName} USD Mobile Balance': '{billingName} USD Мобильний баланс',
		'{billingName} Mobile balance is needed to pay for Mobile Wallet services...':
			'Баланс {billingName} Mobile нужен для оплаты услуг Мобильного кошелька...',
		'More about services': 'Подробнее об услугах',
		'Your balance': 'Ваш баланс',
		'Buy {currency}': 'Купить {currency}',
		'About {currency}': 'О {currency}',
		'What is {currency} for': 'Для чего нужны {currency}',
		'{currency} usage options': 'Возможности использования {currency}',
		'Commission payment': 'Оплата комиссий',
		"You can pay outgoing transaction fees with up to 50% discount using BH USD.\nTry it — it's easy!":
			'Вы можете оплачивать комиссию за исходящие транзакции с выгодой до 50% за счёт BH USD.\nПопробуйте, это просто!',
		'AML check payment': 'Оплата AML проверок',
		'AML checks provide risk assessment information required for compliance procedures. \nInitiate an AML check to obtain risk assessment information.':
			'AML-проверки предоставляют информацию об уровне риска, необходимую для соблюдения процедур комплаенса.\nИнициируйте AML-проверку для получения информации об уровне риска.',
		'To be announced': 'Скоро будет объявлено',
		'Not enough balance': 'Недостаточно средств на балансе',
		'Fee amount_v3': 'Размер комиссии',
		Balance: 'Баланс',
		'Choose fee payment method': 'Выберите способ оплаты комиссии',
		'Choose fee payment method. The cost varies depending on the option chosen.':
			'Выберите способ оплаты. Стоимость зависит от выбранного варианта.',
		'Password and Pin-code have been created': 'Пароль и пин-код созданы',
		'Fee payment method': 'Способ оплаты комиссии',
		'Amount to pay': 'Сумма к оплате',
		'Select payment address': 'Выберите адрес для оплаты',
		Period: 'Период',
		'Last week': 'Последняя неделя',
		'Last month': 'Последний месяц',
		'Last year': 'Последний год',
		'Insufficient balance to pay the commission': 'Недостаточно баланса для оплаты комиссии',
		'Loading error!': 'Ошибка загрузки!',
		Custom: 'Настроить',
		'Select period': 'Выбрать период',
		'Start date': 'Дата начала',
		'end date': 'дата конца',
		'Enter your login and password to verify your identity': 'Введите логин и пароль для подтверждения вашей личности',
		'PIN-code recovery': 'Восстановление PIN-кода',
		'Forgot password?': 'Забыли пароль?',
		'Create a PIN code that will be used to log in and confirm transactions.':
			'Создайте пин-код, который будет использован для входа и подтверждения транзакций.',
		'PIN-code has been restored': 'Пин-код восстановлен',
		'All transactions': 'Все транзакции',
		Today_uppercase: 'СЕГОДНЯ',
		Yesterday_uppercase: 'ВЧЕРА',
		'All wallets': 'Все кошельки',
		'No assets yet': 'Активов пока нет',
		"They'll appear here soon": 'Они появятся здесь позже',

		Add: 'Добавить',
		'Add to Home Screen': 'Добавить на главный экран',
		'Add {productName} to Home Screen': 'Добавьте {productName} на экран «Домой»',
		'Tap the {icon} button at the bottom': 'Нажмите кнопку {icon} «Поделиться» внизу экрана',
		'Select {icon} <p>to Home Screen</p>': 'Выберите {icon} <p>«На экран Домой»</p>',

		'Password recovery': 'Восстановление пароля',
		'The only way to recover your wallet is to complete the recovery procedure through Support':
			'Единственный способ восстановить ваш кошелек — пройти процедуру восстановления через службу поддержки',
		'Send a request and follow the instructions provided in {supportBotName}':
			'Отправьте запрос и следуйте инструкциям, приведенным в {supportBotName}',
		'Send a request': 'Отправить запрос',
		More: 'Больше',
		'Send only {coinName} to this address. Sending any other assets may result in permanent loss.':
			'Отправляйте на этот адрес только {coinName}. Отправка других активов может привести к их потере.',
		'Please note: Once the PIN-code is changed, withdrawal will be disabled for {time}.':
			'Обратите внимание: после изменения PIN-кода вывод средств будет недоступен в течение {time}.',
		Mo: 'Пн',
		Tu: 'Вт',
		We: 'Ср',
		Th: 'Чт',
		Fr: 'Пт',
		Sa: 'Сб',
		Su: 'Вс',
		Apply: 'Применить',
		'{currency} needs to be topped up': 'Нужно пополнить {currency}',
		'Copy error code': 'Скопировать код ошибки',
		Copied: 'Скопировано',
		'Pick a username that hasn’t been taken yet or enter your invite. You can use letters, numbers, dots, and underscores.':
			'Выберите незанятое имя пользователя или введите своё приглашение. Можно использовать буквы, цифры, точки и подчёркивание.',
		'Enter username or invite name': 'Введите логин или приглашение',
		'Terms of Use': 'Условиями использования',
		'I understand that I can only access this wallet using the account I registered with.':
			'Я понимаю, что могу получить доступ к этому кошельку только с использованием учётной записи, с которой проходил регистрацию.',
		'Create password': 'Создать пароль',
		'Create a password for account recovery. IMPORTANT: keep this password safe, and DO NOT lose it':
			'Создайте пароль для восстановления учётной записи. ВАЖНО: сохраните этот пароль в безопасности и НЕ теряйте его',
		'The password must contain from {fromNumber} - {toNumber} characters, including lowercase and uppercase Latin letters and at least one number':
			'Пароль должен содержать от {fromNumber} до {toNumber} символов, включая строчные и заглавные латинские буквы и как минимум одну цифру',
		'Password must contain at least {number} characters': 'Пароль должен содержать не менее {number} символов',
		'Enter your username and PIN-code': 'Введите ваше имя пользователя и PIN-код',
		'Forgot PIN-code?': 'Забыли пин-код?',
		'Welcome back, {username}': 'Добро пожаловать обратно, {username}',
		Swap: 'Обмен',
		Buy: 'Покупка',
		'Recent transactions': 'Недавние транзакции',
		'View all': 'Просмотреть все',
		'Swap is currently unavailable, but we are working on getting it up and running':
			'Обмен в настоящее время недоступен, но мы работаем над его запуском',
		'Buy is currently unavailable, but we are working on getting it up and running.':
			'Покупка в настоящее время недоступна, но мы работаем над ее запуском',
		"You don't have any assets to send. Please top up your balance.":
			'У вас нет активов для отправки. Пожалуйста, пополните баланс',
		'Empty page': 'Пустая страница',
		'There is nothing on this page': 'На этой странице ничего нет',
		'Username must contain at least {number} characters':
			'Имя пользователя должно содержать не менее {number} символов',
		'Enter PIN-code': 'Введите пин-код',
		'You PIN-code is required to authenticate secure actions':
			'Ваш пин-код необходим для аутентификации защищенных действий',
		'Select asset to send': 'Выберите актив для отправки',
		'Select asset to receive': 'Выберите актив для получения',
		"You don't have transactions": 'У вас нет транзакций',
		'Enter address': 'Введите адрес',
		To: 'Кому',
		Next: 'Далее',
		'Please wait': 'Пожалуйста, подождите',
		'The address incorrect': 'Неверный адрес',
		'You’ve already sent USDT. A new transfer will be available once the current transaction is completed.':
			'Вы уже отправили USDT. Новый перевод будет доступен после завершения текущей транзакции.',
		Done: 'Готово',
		Max: 'Max',
		'Network fee': 'Сетевая комиссия',
		'Best price': 'Лучшая цена',
		'Benefit up to': 'Выгода до',
		'Confirm transaction': 'Подтвердить транзакцию',
		'Amount to send': 'Сумма к отправке',
		'Network fee_v2': 'Комиссия сети',
		From: 'От',
		Available_v2: 'Доступно',
		'Insufficient balance for this method.': 'Недостаточно средств для оплаты этим методом.',
		'Attention: The transaction is already in progress from this address.':
			'Внимание: С этого адреса уже выполняется транзакция.',
		Successful: 'Успешно',
		'The transaction has been sent.': 'Транзакция отправлена.',
		'Your payment is being processed.': 'Ваш платеж обрабатывается.',
		'Processing may take some time and involve multiple technical transactions, all of which will be recorded in the transaction history.':
			'Обработка может занять некоторое время и включать несколько технических транзакций, которые будут отображены в истории операций.',
		'Only "A-Z", "a-z", "0-9", "_", "." or "-" allowed': 'Только "A-Z", "a-z", "0-9", "_", "." или "-" допустимо',
		Attention: 'Внимание',
		'Enter amount': 'Введите сумму',
		'Select asset to pay': 'Выберите актив для оплаты',
		'Select address to pay': 'Выберите адрес для оплаты',
		'Password is not valid': 'Некорректный пароль',
		'Enter the characters you see': 'Введите символы с картинки',
		'Can’t read?': 'Не видно?',
		'Enter the CAPTCHA code': 'Введите код CAPTCHA',
		Submit: 'Отправить',
		'Invalid code.': 'Неверный код.',
		'Please try again.': 'Пожалуйста, попробуйте ещё раз.',
		'No addresses yet': 'Адресов пока нет',
		'Creating wallet addresses…': 'Создание адресов кошелька…',
		'Not enough funds to cover the fee': 'Недостаточно средств для оплаты комиссии',
		'Not enough {currency} funds to cover the fee': 'Недостаточно {currency} средств для оплаты комиссии',
		'With this fee, confirmation may take longer than usual.':
			'С этой комиссией подтверждение может занять больше обычного.',
		'Transaction cannot be confirmed with this fee.': 'Транзакция не может быть подтверждена с такой комиссией.',
		'Verification required': 'Требуется проверка',
		'This wallet is already active on another device. To continue using it here, please verify your identity':
			'Этот кошелёк уже активирован на другом устройстве. Чтобы продолжить работу здесь, подтвердите свою личность',
		'Verify identity': 'Подтвердить личность',
		'Verification successful': 'Проверка успешно пройдена',
		'Welcome back!': 'С возвращением!',
		'Confirm login': 'Подтвердите вход',
		'Enter your password to continue': 'Введите пароль, чтобы продолжить',
		'The bot wasn’t created': 'Бот не был создан',
		Devices: 'Устройства',
		'Use your account on multiple devices': 'Используйте аккаунт на нескольких устройствах',
		'This device': 'Это устройство',
		Online: 'В сети',
		'Terminate all other sessions': 'Завершить остальные сеансы',
		'Logs out all devices except for this one.': 'Завершит сеансы на всех устройствах, кроме текущего.',
		'Active sessions': 'Активные сеансы',
		'Enter PIN': 'Введите PIN',
		'PIN is required to confirm this action': 'Для подтверждения действия введите PIN',
		Language: 'Язык',
		'Interface language': 'Язык интерфейса',
		'Estimated blockchain fee maximum. You are only charged the actual network fee at the moment of confirmation.':
			'Максимальная оценка комиссии блокчейна. С вас взимается только фактическая комиссия сети на момент подтверждения.',

		//ДЛЯ ТЕСТА
		'Card is Frozen. Unfreeze it to use.': 'Card is Frozen. Unfreeze it to use.',
		'Unfreeze card': 'Unfreeze card',
		'The action cannot be undone': 'The action cannot be undone',
		'Close card': 'Close card',
		'Number card copied': 'Number card copied',
		'Number card': 'Number card',
		Expiration: 'Expiration',
		'Crypto wallet': 'Crypto wallet',
		'All cards': 'All cards',
		'6-digit code': '6-digit code',
		'Enter the 6-digit verification code we send to your email to contune.':
			'Enter the 6-digit verification code we send to your email to contune.',
		'Enter the 6-digit verification code we send to your phone to contune.':
			'Enter the 6-digit verification code we send to your phone to contune.',
		'Enter the 6-digit verification code we send to your email and phone number to contune.':
			'Enter the 6-digit verification code we send to your email and phone number to contune.',
		'Resend code': 'Resend code',
		'Resend code in': 'Resend code in',
		'Select asset to top up': 'Select asset to top up',
		'Only send {coinName} assets to this address. Other assets will be lost forever.':
			'Only send {coinName} assets to this address. Other assets will be lost forever.',
		"You don't have any addresses on card.": "You don't have any addresses on card.",
		'The minimum top-up amount is {amountUSD} USD': 'The minimum top-up amount is {amountUSD} USD',
		'Top up address': 'Top up address',
		'Amount to up': 'Amount to up',
		'Select asset to withdrawal': 'Select asset to withdrawal',
		Withdrawal: 'Withdrawal',
		//ДЛЯ ТЕСТА

		'AML risk indicates the potential exposure of funds to illicit or high-risk activity.':
			'AML-риск показывает потенциальную связь средств с незаконной или высокорисковой активностью.',
		'What does this mean?': 'Что это значит?',
		'The risk level is calculated based on transaction history and connections to various sources and counterparties.':
			'Уровень риска рассчитывается на основе истории транзакций и связей с различными источниками и контрагентами.',
		'It helps identify whether funds may be associated with sanctions, fraud, illegal services, or other risky activity.':
			'Он помогает определить возможную связь средств с санкциями, мошенничеством, нелегальными сервисами и другой рискованной активностью.',
		'What should you do?': 'Что делать?',
		'Use AML risk as a reference when interacting with addresses.':
			'Используйте показатель AML-риска как ориентир при работе с адресами.',
		'Review detailed AML information to better understand the nature and origin of funds.':
			'Изучайте детальную AML-информацию, чтобы лучше понять происхождение и характер средств.',
		'No AML checks yet. Run an AML check to review potential risks for this address.':
			'AML-проверки пока не выполнялись. Запустите AML-проверку, чтобы оценить возможные риски по этому адресу.',
		'Learn more v2': 'Подробнее',
		'Recent AML checks': 'Недавние AML-проверки',
		'View all v2': 'Показать все',
		'Payment purpose': 'Назначение платежа',
		'Attached files': 'Прикреплённые файлы',
		'Files attached to this payment': 'Файлы, прикреплённые к этому платежу',
		'Access restricted': 'Доступ ограничен',
		'Your current location is included in the list of restricted countries configured by the Administrator (root).':
			'Ваша текущая локация входит в список запрещённых стран, настроенный Администратором (root).',
		'Upload files': 'Загрузка файлов',
		'Maximum file size: 10 MB': 'Максимальный размер файла: 10 МБ',
		'Attach supporting files for this payment': 'Прикрепите файлы, подтверждающие платёж',
		'Attach files': 'Прикрепить файлы',
		Type: 'Тип',
		'More details': 'Подробнее',
		'Something went wrong while checking the address. Please try again or come back later.':
			'При проверке адреса что-то пошло не так. Попробуйте повторить попытку или вернуться позже.',
		'AML check history': 'История AML-проверок',
		m: 'м',
		s: 'с',
		'Address already checked': 'Адрес уже проверен',
		'The AML check request was canceled because this address already has a valid and up-to-date AML result.':
			'Запрос на AML-проверку был отменён, так как для этого адреса уже есть актуальный результат AML-проверки.',
		'To proceed, you must provide a payment purpose or attach a supporting file.':
			'Для продолжения необходимо указать назначение платежа или прикрепить подтверждающий файл.',
		Unverified: 'Нет данных',
		'This address hasnt appeared in any known AML records — flagged or otherwise.':
			'Адрес не замечен ни в каких AML-базах: ни среди подозрительных, ни среди доверенных.',
		'No risk data available — this address has no recorded activity.':
			'Данные о рисках отсутствуют — активность по адресу не зафиксирована.',
		'The address does not match the selected network': 'Адрес не соответствует выбранной сети',
		'Choose the correct blockchain.': 'Выберите правильный блокчейн.'
	},
};

export default ru;
